import { Component, OnDestroy } from "@angular/core";

import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { SmartGridBaseConfigService } from "src/app/data-grid/smart-grid-base-config.service";
import { Subject } from "rxjs";

@Component({
  selector: "app-discount-price-percent-cell-edit",
  templateUrl: "./discount-price-percent-cell-edit.component.html",
  styleUrls: ["./discount-price-percent-cell-edit.component.scss"],
})
export class DiscountPricePercentCellEditComponent
  implements OnDestroy, ICellRendererAngularComp
{
  params: any;
  type: "amount" | "percent";
  amount: string;
  percent: string;
  key: string;
  isNumber: boolean;
  min: number;
  private destroy$ = new Subject<void>();
  constructor( public SmartGridBaseConfigService: SmartGridBaseConfigService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.amount = this.params.data[this.params.amountKey];
    this.percent = this.params.data[this.params.percentKey];
    this.isNumber = this.params.isNumber;
    this.min = this.params.min;
    if (this.percent) {
      this.key = this.params.percentKey;
      this.type = 'percent';
    } else {
      this.key = this.params.amountKey;
      this.type = 'amount';
    }
  }

  discountBy(event): void {
    this.type = event.value;
    if (event.value === 'amount') {
      this.key = this.params.amountKey;
      this.params.data[this.params.amountKey] = Math.round(this.params.data[this.params.percentKey] * 100) / 100;
      this.params.data[this.params.percentKey] = 0;
    } else {
      this.key = this.params.percentKey;
      this.params.data[this.params.percentKey] = this.params.data[this.params.amountKey];
      this.params.data[this.params.amountKey] = 0;
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  valueChange(event): void {
    this.params.setValue(Number(event.target.value));
    if (this.params.callback) {
      this.params.callback(this.params);
    }
  }

  restrictMinus(event) {
    if (event.which === 45) return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}